function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var validateNonZeroLengthString = function validateNonZeroLengthString(str, name) {
  if (typeof str !== 'string' || str.length === 0) {
    throw new Error("".concat(name, " must be a non-zero length string. Got: ").concat(str, "."));
  }
};

/**
 * Sets the event object for Google anlytics
 * @param {string} widgetName - A string value for widgetName
 * @param {string} widgetId - A string value for widgetId
 * @param {object} trackingObj - An object value for trackingObj
 */

var trackEvent = function trackEvent(widgetName, widgetId, trackingObj) {
  validateNonZeroLengthString(widgetName, 'Widget name');
  validateNonZeroLengthString(widgetId, 'Widget id');
  var isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    var _window = window,
        _window$DDC = _window.DDC,
        DDC = _window$DDC === void 0 ? {} : _window$DDC;
    var defaultTrackingObj = {
      action: 'clicked',
      element: undefined,
      elementCTA: undefined,
      event: 'widgetUserEvent',
      fieldValue: undefined,
      formEventId: undefined,
      formId: undefined,
      nonInteractive: false,
      result: undefined,
      sourceData: undefined,
      value: undefined,
      widgetId: widgetId,
      widgetName: widgetName,
      widgetState: 'default'
    };

    if (DDC.fireTrackingEvent) {
      DDC.fireTrackingEvent(_objectSpread2({}, defaultTrackingObj, {}, trackingObj));
    }

    return !!DDC.fireTrackingEvent;
  }

  return isBrowser;
};

export { trackEvent };
//# sourceMappingURL=es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/ddc-track-event/dist/es.js
// module id = 72
// module chunks = 0